import { PartialNullable } from "../../Extensions";
import { Property } from "../../RadObject";
import { WebApiClientService } from "../../Server/WebApiClientService";
import { ServiceManager } from "../../ServiceManager";
import { CheckBoxListPermissionEntity, CheckBoxListPermissionEntityPropertyValues, ICheckBoxListPermissionEntity } from "./CheckBoxListPermissionEntity";
import { NAMESPACE } from "./_Namespace";

export type CheckBoxListPermissionEntityPropertyPropertyValues =
    CheckBoxListPermissionEntityPropertyValues
    & {
    };

export type CheckBoxListPermissionEntityPropertyProperties = {
    [name in keyof CheckBoxListPermissionEntityPropertyPropertyValues]: Property<CheckBoxListPermissionEntityPropertyPropertyValues[name]>
};

export interface ICheckBoxListPermissionEntityProperty extends ICheckBoxListPermissionEntity, CheckBoxListPermissionEntityPropertyProperties
{
}

export class CheckBoxListPermissionEntityProperty extends CheckBoxListPermissionEntity implements ICheckBoxListPermissionEntityProperty
{
    // #region Static

    public static override classNamespace = NAMESPACE + "CheckBoxListPermissionEntityProperty";
    public static override className = "CheckBoxListPermissionEntityProperty";

    // #region Overrides

    public static override createPropertyDefaults(): PartialNullable<CheckBoxListPermissionEntityPropertyPropertyValues>
    {
        return {
            ...super.createPropertyDefaults(),
            ...{
            }
        };
    }

    // #endregion

    // #endregion

    // #region Instance

    // #region Overrides

    protected override __initializeProperties(propertyValues: CheckBoxListPermissionEntityPropertyPropertyValues)
    {
        super.__initializeProperties(propertyValues);

        this.mandatory.overrideSet((value, next) => next(false));
        this.mandatoryEvaluator.overrideSet((value, next) => next(null));
    }

    public override async loadDataAsync()
    {
        const
            data =
                await ServiceManager.getRequired(WebApiClientService)
                    .createApiMethodRequest("DataService", "CallDataService", { id: "48f9aaee-42b3-4315-a1df-7276230deb2a" })
                    .executeAsync();

        this.listDataSource.set(data.map((item: any) => ({ value: item.value, description: item.description })));
    }
    public override updateMandatory()
    {
        // Don't show mandatory state as we default to 0
        this.removeCssClass("rad-state-mandatory");
    }

    // #endregion

    // #endregion
}
